import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import {map, Observable} from 'rxjs';
import {ApiErrorDto} from "./models/api-error";
import {ApiErrorService} from "./api-error.service";
import {environment} from "../../../environments/environment";

@Injectable()
export class ApiErrorInterceptor implements HttpInterceptor {

  constructor(private apiErr: ApiErrorService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request)
      .pipe(map((event: HttpEvent<any>) => {

        if (event instanceof HttpResponse) {
          if (event.status >= 400) {
            const err = event.body as ApiErrorDto;
            if (!environment.production) {
              console.log(err)
            }

            this.apiErr.addError(err)
          }
        }

        return event
      }))
  }
}
